import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const headerMenuStyles = makeStyles((theme: Theme) =>
    createStyles({
        grow: {
            flexGrow: 1,
        },
        main: {
            minHeight: "50px",
            padding: "0px",
        },

        text: { margin: "10px 10px 10px 10px", color: "#000000DE" },
        dates: {
            paddingTop: "1px",
            fontSize: "15px",
        },
        calendarInput: {
            width: "140px",
            borderRadius: theme.shape.borderRadius,
            border: 1,
            borderStyle: "solid",
            borderColor: theme.colors.neutrals.neutral300,
            paddingLeft: 5,
            ...theme.typography.body1,
            height: "initial",
        },
        selectedText: {
            color: "#000000DE",
            display: "inline",
        },
        Unselected: {
            display: "inline",
            color: "#00000061",
        },
        listItemDisplay: {
            paddingRight: "8px",
            display: "inline",
            "&:hover": {
                backgroundColor: "#fff !important",
            },
        },
        button: {
            marginRight: "20px",
            width: "110px !important",
            height: "32px",
            color: "#616161 !important",
            backgroundColor: "white !important",
            border: " 1px solid rgba(0, 0, 0, 0.23)",
            "&:hover": {
                backgroundColor: "rgb(189, 189, 189,0.2) !important",
            },
        },
        selected: {
            backgroundColor: "#fff !important",
        },
        filterBtn: {
            [theme.breakpoints.up("sm")]: {
                marginLeft: theme.spacing(2.7),
                width: "52px",
            },
            border: "1px solid #BDBDBD80",
            borderRadius: "4px",
            height: "34px",
            marginRight: "20px",
        },
        openFilterBtn: {
            [theme.breakpoints.up("sm")]: {
                marginLeft: theme.spacing(2.7),
                width: "52px",
            },
            backgroundColor: theme.colors.primary.blue500,
            border: "1px solid #BDBDBD80",
            borderRadius: "4px",
            height: "34px",
            "&:hover": {
                backgroundColor: theme.colors.primary.blue500,
            },
            marginRight: "20px",
        },
        datePickerWrapper: {
            display: "flex",
        },
        picker: {
            "&:focus-visible": {
                outline: "none",
            },
            "&:focus": {
                border: "1px solid rgba(39, 10, 220, 1)",
            },
            fontSize: "14px",
            fontWeight: 500,
            paddingLeft: "10px",
            height: "33px",
            width: "200px",
            border: " 1px solid rgba(0, 0, 0, 0.23)",
            borderRadius: "4px",
        },
    })
);
